import React, { Fragment } from 'react';
import Divider from '@mui/material/Divider';
import Typography from "@mui/material/Typography";
import StaticDisplyALevelRequirements from './HelperChunks/StaticDisplyALevelRequirements';

const ALevelEntryRequirements = () => {
    return (
        <Fragment>
        <div style={{ padding: 20 }}>
                <Typography style={{ color: '#1d5f98', fontWeight: 600, fontSize: 20 }} variant="h5">
                    Entry Requirements
                </Typography>
                <Divider style={{
                backgroundColor: 'rgb(58, 127, 187)',
                opacity: '0.3'
            }} />
            </div>
            <StaticDisplyALevelRequirements />
        </Fragment>
    );
}

export default ALevelEntryRequirements;